export default __webpack_public_path__ + "static/N0095-5735df238f1244f9158a13f42e7edb74.png";